import React, { useEffect } from 'react';
import Userfront from '../../auth/userfrontCompat';
import { usePersistentCollapsedState } from './../../components/SidebarContext';
import { useTranslation } from 'react-i18next';
import api from './../../api/axios';
import i18n from './../../i18n';

import Sidebar from './../../components/Sidebar';
import NavBar from './../../components/Navbar';
import Onboarding from './../../components/OnboardingWidget'; // your new component

const OnboardingPage = () => {
  const { t } = useTranslation();
  const currentUser = Userfront.user.email;
  const collapsed = usePersistentCollapsedState();

  useEffect(() => {
    const fetchUserLanguage = async () => {
      try {
        const response = await api.get(`/user/user`);
        const userLanguage = response.data.language || 'en';
        i18n.changeLanguage(userLanguage);
      } catch (error) {
        console.error('Error fetching user language settings:', error);
      }
    };

    fetchUserLanguage();
  }, [currentUser]);

  return (
    <div className="w-full">
      <div className="min-h-screen transition-all px-2 sm:px-4 md:px-6 lg:px-8 bg-gray-50">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-4 border-b mb-4">
          <div>
            <h1 className="text-2xl font-semibold text-gray-800">
              {t('onboarding.title')}
            </h1>
            <p className="text-sm text-gray-600">{t('onboarding.subtitle')}</p>
          </div>
        </div>

        {/* Main Onboarding Flow */}
        <Onboarding />
      </div>
    </div>
  );
};

export default OnboardingPage;
